export default {
  title: 'Dispositivos',
  subtitle: 'Localizadores e rastreadores da conta.',
  add: 'Ativar dispositivo',
  search_placeholder: 'Buscar por nome, categoria…',
  empty: 'Nenhum dispositivo cadastrado ainda.',
  empty_hint: 'Ative seu primeiro localizador para começar.',
  no_name: 'Sem nome',
  empty_filtered: 'Nenhum dispositivo corresponde aos filtros.',
  filter_update: 'Filtrar por atualização',
  filter_all: 'Todas',
  last_seen_never: 'Nunca localizado',
  last_seen_now: 'Última posição agora mesmo',
  last_seen: 'Última posição {time}',
  table: {
    device: 'Dispositivo',
    category: 'Categoria',
    detection: 'Detecção',
    battery: 'Bateria',
    status: 'Status',
  },
  detail: {
    back_to_map: 'Voltar ao mapa',
    last_location: 'Última localização',
    detection: 'Detecção',
    update: 'Atualização',
    accuracy: 'Precisão',
    source: 'Origem',
    battery: 'Bateria',
    identification: 'Identificação',
    tag_code: 'Código do localizador',
    serial: 'Serial do fabricante',
    provider_id: 'ID no provedor',
    groups: 'Grupos',
    no_groups: 'Nenhum grupo.',
    recent_history: 'Histórico recente',
    retention: 'Retenção do plano: {days} dias.',
    hide_map: 'Ocultar mapa',
    show_map: 'Ver no mapa',
    positions: '{count} posição | {count} posições',
    last_detection: 'Última detecção',
    last_update: 'Última atualização',
    recent_observations: 'Observações recentes',
    no_detections: 'Nenhuma posição ainda.',
    edit_tag: 'Editar dispositivo',
    discard_changes: 'Descartar as alterações?',
    unavailable: 'Este dispositivo não está mais disponível para você.',
    not_found: 'Dispositivo não encontrado ou sem permissão de acesso.',
    waiting_first: 'A localização aparecerá quando a primeira posição chegar.',
  },
}
